<script setup>
import Icon from '/app/components/NIcon.vue';
import { usePlatform } from '/app/composables/platform';

const { contextPlatform } = usePlatform();

const props = defineProps({
    size: {
        type: String,
        default: 'small',
        validator(value) {
            return ['small', 'large'].indexOf(value) > -1;
        },
    }
})
</script>

<template>
    <img
        v-if="contextPlatform?.icon" :src="`https://category-icons.bignerve.com/${contextPlatform.icon}`"
        :class="size === 'small' ? 'h-4 w-4' : 'h-5 w-5'"
        :alt="contextPlatform?.title"
        @error="e => e.target.src = `https://category-icons.bignerve.com/article-draft-icon.svg`"
    >
    <Icon v-else as="question-circle" :class="size === 'small' ? 'text-md' : 'text-xl'"/>
</template>